import {PageFragment, PageFragmentProps, PageFragmentState} from "shared/PageFragment";

export enum PermissionsState {
  GRANTED,
  DENIED,
  NOT_GRANTED,
}

export type BaseMeetingFragmentProps = PageFragmentProps & {}

export type BaseMeetingFragmentState = PageFragmentState & {
  permissionsState?: PermissionsState,
}

export abstract class BaseMeetingFragment<P extends BaseMeetingFragmentProps = BaseMeetingFragmentProps, S extends BaseMeetingFragmentState = BaseMeetingFragmentState> extends PageFragment<P, S> {

}
